import React, { useState, useEffect, useCallback } from "react";
import { Element } from "react-scroll";

import Sidebar from "../Sidebar/Sidebar";
import ProjectListing from "../ProjectListing/ProjectListing";
import ExperienceListing from "../ExperienceListing/ExperienceListing";
import AcademicListing from "../AcademicListing/AcademicListing";
import Contact from "../Contact/Contact";
import MobileSectionNav from "./MobileSectionNav";
import "./Content.css";

const Content = () => {
  const [revealSidebar, setRevealSidebar] = useState(false);

  const checkScrollTop = useCallback(() => {
    if (!revealSidebar && window.scrollY > window.innerHeight * 0.8) {
      setRevealSidebar(true);
    } else if (revealSidebar && window.scrollY <= window.innerHeight * 0.8) {
      setRevealSidebar(false);
    }
  }, [revealSidebar, setRevealSidebar]);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [checkScrollTop]);

  return (
    <div className="content-wrapper">
      <div className="content-container">
        <Sidebar reveal={revealSidebar} />
        <div className="content-main">
          <MobileSectionNav />
          <Element name="experiences">
            <ExperienceListing />
          </Element>
          <hr className="content-divider" />
          <Element name="projects">
            <ProjectListing />
          </Element>
          <hr className="content-divider" />
          <Element name="academic">
            <AcademicListing />
          </Element>
          <hr className="content-divider" />
          <Element name="contact">
            <Contact />
          </Element>
        </div>
      </div>
    </div>
  );
};

export default Content;
